import React from 'react';
import Grid from '@mui/material/Grid';
import { Box, SelectChangeEvent } from '@mui/material';
import Button from '@shared-components/atoms/Button';
import ProductOptionsDropdown from '../ProductOptionsDropdown';
import SelectorButton from '../../../../coreComponents/buttons/SelectorButton';
import useStyles from '../styles';
import { ButtonProps } from '@/coreComponents/buttons/SelectorButton/SelectorButton';
import { DisplayableModifier } from '@/domain/product/types';
import { SelectorButtonState } from '@/hooks/useButtonState';
import { CtaButton } from '@/coreComponents/buttons/CtaButton/CtaButton';
import css from '@/clientCore/menu/components/MultiRecipeSelection/MultiRecipeSelection.module.css';

interface ProductDropdownsWithAddToCartProps {
  id: string;
  productNameWithoutSpaces: string;
  hasMultipleSizes: boolean;
  hasAdditionalOptions: boolean;
  formattedUnitPrice: string;
  quantity: number;
  showQuantity?: boolean;
  productName: string;
  sizes: DisplayableModifier[] | undefined;
  selectedSize?: DisplayableModifier;
  updateSize: (
    event: SelectChangeEvent,
    child: React.ReactNode
  ) => void;
  additionalOptions: DisplayableModifier[];
  selectedAdditionalOption?: DisplayableModifier;
  updateAdditionalOption: (
    event: SelectChangeEvent,
    child: React.ReactNode
  ) => void;
  handleAddToCart: (e: MouseEvent, param: boolean, upcharge: number) => void;
  handleCustomizeMelt: (meltID:string) => void;
  updateQuantity: (
    event: SelectChangeEvent,
    child: React.ReactNode
  ) => void;
  buttonState: SelectorButtonState;
  buttonDetails: ButtonProps;
  quantitySelectorInputLabel: string;
  isMyHutBoxProduct?: boolean;
  isMelt: boolean;
  clickHandler?: () => void;
}

const ProductDropdownsWithAddToCart = (props: ProductDropdownsWithAddToCartProps): JSX.Element => {
  const {
    id,
    productName,
    productNameWithoutSpaces,
    hasMultipleSizes,
    hasAdditionalOptions,
    formattedUnitPrice,
    sizes,
    additionalOptions,
    quantity,
    showQuantity = true,
    buttonState,
    updateSize,
    selectedSize,
    selectedAdditionalOption,
    updateAdditionalOption,
    updateQuantity,
    handleAddToCart,
    handleCustomizeMelt,
    quantitySelectorInputLabel,
    buttonDetails,
    isMyHutBoxProduct,
    isMelt,
    clickHandler
  } = props;

  const classes = useStyles({isMelt});

  return (
    <Grid className={classes.ctaContainer}>
      {hasMultipleSizes && (
        <ProductOptionsDropdown
          id={id}
          productName={productName}
          productNameWithoutSpaces={productNameWithoutSpaces}
          formattedUnitPrice={formattedUnitPrice}
          selectedProductOption={selectedSize}
          productOptions={sizes}
          updateProductOption={updateSize}
          label="Sizes"
          type="sizes"
        />
      )}
      {hasAdditionalOptions && (
        <ProductOptionsDropdown
          id={id}
          productName={productName}
          productNameWithoutSpaces={productNameWithoutSpaces}
          formattedUnitPrice={formattedUnitPrice}
          selectedProductOption={selectedAdditionalOption}
          productOptions={additionalOptions}
          updateProductOption={updateAdditionalOption}
          label="Additional Options"
          type="additional-options"
        />
      )}
      <Grid className={classes.sizeDropdownAndCtaButtonWrapper}>
        {isMelt && (
          <Box mr={2}>
            <Button
            className={css['product-tile__cta-link']}
            aria-label={`Customize ${productName}`}
            onClick={() => handleCustomizeMelt(id)}
            variant='link'
            >
              Customize
          </Button>
          </Box>
        )}
        { isMyHutBoxProduct ? (
          <CtaButton
            color="secondary"
            labelText="Get Started"
            size="medium"
            clickHandler={clickHandler}
          />
        ) : (
          <SelectorButton
            onClick={(e) => handleAddToCart(e as MouseEvent, false, selectedSize?.upcharge ?? 0)}
            onSelectionChange={updateQuantity}
            quantity={quantity}
            showQuantity={showQuantity}
            inputLabelText={quantitySelectorInputLabel}
            button={buttonDetails}
            select={{
              id: productNameWithoutSpaces,
              name: 'quantity'
            }}
            state={buttonState}
          />
        )}
      </Grid>
    </Grid>
  );
};

export default ProductDropdownsWithAddToCart;
